import {BackendPostManager} from 'components/Backend/Post/Manager';

export const title = '捷克文章紀錄';
export default BackendPostManager;
